export enum ServiceType {
    JIRA,
    HUBSPOT,
    INVOICING,
    IDWAL_EXTERNAL_API,
    FLEET_PERFORMANCE
}
